import {
  checkUserGroup,
  getCertList,
  getGrocery,
  getUserRight,
} from "@/services";
import { getExpsValue } from "@/tracker/abTest";
import useRequest from "@/utils/useReq";
import { createContext, useMemo } from "react";

export const VipDialogContext = createContext({
  config: null,
  rightData: null,
});

export function useDialogContext(userRight) {
  const { data: config } = useRequest(async () => {
    const data = await getGrocery("vip-buydialog");

    // 这块处理主要是用于用户分群
    const map = {};
    const list = [
      ...(data?.personal?.cardsByGroup || []),
      ...(data?.company?.cardsByGroup || []),
    ];
    const groupIds = list.reduce((result, item) => {
      item?.groupIds?.forEach((id) => {
        if (!map[id]) {
          result.push(id);
          map[id] = true;
        }
      });

      return result;
    }, []);

    if (groupIds?.length > 0) {
      const groupIdMap = await checkUserGroup({ group_ids: groupIds });

      const personalGroup = data?.personal?.cardsByGroup?.find((group) =>
        group.groupIds.some((id) => groupIdMap[id])
      );

      if (personalGroup) {
        data.personal.cards = personalGroup.list;
      }

      const companyGroup = data?.company?.cardsByGroup?.find((group) =>
        group.groupIds.some((id) => groupIdMap[id])
      );

      if (companyGroup) {
        data.company.cards = companyGroup.list;
      }
    } else {
      // 优先级比用户分群低，当有匹配的用户分群时，不执行ABTest策略
      // 个人会员支持ABTest测试顺序,
      if (data?.personal?.abtest) {
        const abValue = await getExpsValue(data?.personal?.abtest, "0");
        const matchList = data.personal?.cardsByABTest?.find(
          (item) => item.abValue === abValue
        )?.list;

        if (matchList) {
          data.personal.cards = matchList;
        }
      }
    }

    return data;
  });

  const { data: rightData } = useRequest(async () => {
    return userRight || getUserRight();
  });

  const { data: certSubjects } = useRequest(async () => {
    const res = await getCertList({
      valid: 1,
      page_size: 200,
    });

    return res.list || [];
  });

  const contextState = useMemo(() => {
    return {
      config,
      rightData,
      certSubjects,
    };
  }, [certSubjects, config, rightData]);

  return contextState;
}
